<div class="social-callback-root">
  <div class="callback-card">
    <div class="icon-wrap">
      <img class="status-icon" [src]="statusIcon" alt="status" />
    </div>

    <div class="provider-area">
      <img class="provider-icon" [src]="providerIcon" alt="provider" />
      <div class="provider-text">
        <div class="provider-name">{{ provider | titlecase }}</div>
        <div class="provider-sub">Connected via social provider</div>
      </div>
    </div>

    <div class="status-text" [ngClass]="isSuccess ? 'success' : 'failure'">
      {{ status | titlecase }}
    </div>

    @if (isSuccess) {
      <div class="message">
        You're all set — your account was connected successfully.
      </div>
    }
    @if (!isSuccess) {
      <div class="message">
        @if (message) {
          {{ message }}
        } @else {
          There was a problem connecting. Please try again or return to the app.
        }
      </div>
    }
  </div>
</div>
